module.exports = __webpack_public_path__ + "img/signin.fff12117.jpg";